import { Component, OnInit, Input, Injectable, ChangeDetectorRef } from '@angular/core';
import { ApplicationService } from 'app/services/application.service';
import { StatusService } from 'app/services/status.service';
import { AuthWebService } from 'app/services/authweb.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { VehicleEntryService } from 'app/services/vehicle-entry.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { CountryService } from 'app/services/country.service';
import { VehicleMakeService } from 'app/services/vehicle-make.service';
import { VehicleTypeService } from 'app/services/vehicle-type.service';
import { environment } from '../../../../src/environments/environment';
import {NgbCalendar, NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct, NgbActiveModal, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

import { VehicleService } from 'app/services/vehicle.service';
import { Location, DatePipe } from '@angular/common';
import { PermitTypeService } from 'app/services/permit-type.service';
import { VehicleEntryCarrierService } from 'app/services/vehicle-entry-carrier.service';
import { PopupService } from 'app/services/shared/popup.service';
import { Baseservice } from 'app/services/baseservice';
import { DocumenttypeService } from 'app/services/documenttype.service';
import { DocumentsServiceService } from 'app/services/documents-service.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CarrierService } from 'app/services/carrier.service';
import { ConfirmDialogService } from 'app/services/shared/confirm-dialog/confirm-dialog.service';



/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {

  readonly DELIMITER = '/';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day : parseInt(date[0], 10),
        month : parseInt(date[1], 10),
        year : parseInt(date[2], 10)
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

  readonly DT_FORMAT = 'DD/MM/YYYY';

    parse(value: string): NgbDateStruct {
        if (value) {
            value = value.trim();
            let mdt = moment(value, this.DT_FORMAT)
        }
        return null;
    }
    format(date: NgbDateStruct): string {
        if (!date) return '';
        let mdt = moment([date.year, date.month - 1, date.day]);
        if (!mdt.isValid()) return '';
        return mdt.format(this.DT_FORMAT);
    }
}


declare var $;
@Component({
  selector: 'app-external-vehicles',
  templateUrl: './external-vehicles.component.html',
  styleUrls: ['./external-vehicles.component.css'],
  providers: [
    {provide: NgbDateAdapter, useClass: CustomAdapter},
    {provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter},
    NgbActiveModal,
  ]
})
export class ExternalVehiclesComponent implements OnInit {

  @Input('ctrlData') ctrlData: any;
  permits: any = [];
  currentDate:any={day:new Date().getDate(),month:(new Date().getMonth()+1),year:new Date().getFullYear()}
  statuses: any = [];
  flags = { flagAN: 1, flagNM: 1, flagLU: 1, flagCT: 1, flagAP: 1, flagPT: 1, flagST: 1, flagDS: 1 };
  ranks = { flagAN: 1, flagNM: 2, flagLU: 3, flagCT: 4,flagAP: 5, flagPT: 6, flagST: 7, flagDS: 8 };
  sortLabels = { flagAN: "AccountNumber", flagNM: "Name", flagLU: "LeadUser", flagCT: "CarrierType", flagAP: "ApplicationNumber", flagPT: "PermitType", flagST: "Status", flagDS: "DateSubmitted" };
  direction: boolean = false;
  criteria = "DateSubmitted";
  rankCtrl: number = 8;
  isLoading: Boolean = false;
  message: string = 'Loading  vehicles, please wait...';
  statuses1: any = [];

  //Search Variables
  eNatisCounter = 0;
  vehicletypes: any =[];
  permittypes: any = [];
  vinnumber: string;
  vehicleType: string = "";
  permitType: string = "";
  regnumber: string;
  carriername: string;
  carriercode: string;
  found = false;
  keyword: any = {};
  currentPage = 1;
  isEmpty: boolean = false;
  IsSearching:boolean = false;
  IsAdmin:boolean= false;
  pageSize: number = 10;
  page:any=1;
  count: number = 0;
  disabled = false;
  ShowFilter = false;
  limitSelection = false;
  selectedItems: any = [];
  dropdownSettings: any = {};
  registerNumber: string;
  isDef: boolean = true;
  vehicleRes:any=[];
  isEditData:boolean=false;
  isViewData:boolean=false;
  myForm:UntypedFormGroup;
  ddlCountries:any=[];
  list_vehicle_make:any=[];
  list_vehicle_type:any=[];
  list_vehicle_types:any=[];
  selectedVMake:any;
  btnAddNew: boolean;
  leased: any;
  appid:any = null;
  @Input() dataCntrl: any;
  isMyVehicles = false;
  permit_type_id:any;
  isSame = false;
  myAppVehicles = [];

  model: NgbDateStruct;
  date: {year: number};
  selectedVehicles:any=[];
  selectedCountry:any=null;
  license_expiry_date_global: any;


  carrierId: any;
  isVehicleLoading:boolean=false;
  isDocumentLoading:boolean=false;
  uploadedDocs:any=[];
  maxMB: any="5MB";
  dtype: any="PDF,JPG,PNG,JPEG";
  docTypeId: any;
  filebytes: string;
  filename: any;
  filetype: any;
  filedescription: string;
  filesize: any;
  user = { LastName: '' };
  vehicleId: number;
  documentType: any;
  isLoadingImg: boolean;
  selectItem: any;
  viewDocuments:any=[];
  pdfSrc: any;
  img: any;

  linkedDocs: any;
  isExtra: boolean;
  personsList:any=[];
  isExternal: boolean = false;
  eNatisResult: any=null;
  isSouthAfrica = false;
  //disallowEdit = false;

  constructor(private toastr: ToastrService,
    private vehicleEntryService:VehicleEntryService,private countryService:CountryService,private vehicleMakeService:VehicleMakeService,
     private authWebService: AuthWebService,private vehicleTypeService:VehicleTypeService, private permitTypeService: PermitTypeService,
      public utility: UtilityServiceService, private ngbCalendar: NgbCalendar, private dateAdapter: NgbDateAdapter<string>,
       private router: Router,private activeRoute: ActivatedRoute,private vehicleService:VehicleService,
       private _location: Location,private formBuilder: UntypedFormBuilder,private datePipe:DatePipe,
       private applicationService:ApplicationService, private vehicleEntryCarierService:VehicleEntryCarrierService,private msgService: PopupService,
       private documenttypeSerivce:DocumenttypeService,private documentService: DocumentsServiceService,
       private ref: ChangeDetectorRef,private sanitizer: DomSanitizer,private showModal: PopupService,
       private carrierService:CarrierService,private confirmDialogService: ConfirmDialogService
    ) {
    }

  ngOnInit() {
    this.user.LastName = (this.authWebService.userData) ? this.authWebService.userData.User.LastName : '';
    this.user = (this.authWebService.userData) ? this.authWebService.userData.User : null;
      this.listCountries();
      this.getVehicleMake();
      this.loadAccounts();
      this.loadvehicletypes();
      this.getPermitTypes();
      if(this.router.url.indexOf('vehicle/list')>0){
        // this.activeRoute.params.subscribe((params: Params) => {
        // });
        this.isExternal = true;
      }
      this.createForm();
  }

  listCountries(){
    
    this.countryService.listCountries().subscribe(result => {
      
      this.ddlCountries = result;
      //console.log(result);
    }, error => {
      //console.log(error);
    });
  }

  getVehicleMake() {
    if(this.list_vehicle_make.length <= 0)
    this.vehicleMakeService.getAll().subscribe((result:any) => {
      this.list_vehicle_make = result
      this.selectedVMake = result.find(x => x.code == 'Unknown');
      //console.log(this.list_vehicle_make)
    }, error => {
      //console.log(error);
    });
  }

  getVehicleType() {
    this.vehicleTypeService.getPermitTypeVehicles().subscribe((result:any) => {
      this.list_vehicle_type = result.filter(x=>x.permit_type_id === this.permit_type_id);
      //console.log(this.list_vehicle_type)
      if(this.list_vehicle_type.length > 0)
      {
        this.btnAddNew = true
      }
      //console.log(this.btnAddNew)
      //console.log(this.list_vehicle_type.length)
    }, error => {
      //console.log(error);
    });
  }

  loadvehicletypes = () => {
    this.vehicleTypeService.loadvehicletypes().subscribe(result => {
      //console.log('list of vehicle types', result);
      // this.vehicletypes = result.map(row => {
      //   return { id: row.id, desc: row.description };
      // });
      this.vehicletypes = result;
    });
  }

  getPermitTypes()
    {
      this.permitTypeService.get().subscribe(result => {
        //console.log('list of permit types', result);
        // this.vehicletypes = result.map(row => {
        //   return { id: row.id, desc: row.description };
        // });
        this.permittypes = result;
      });
    }

    // onBack() {
    //   this.router.navigate(['/carrier/permit/application/edit',this.appid]);
    // }

    getVehicles(personId){
        this.isLoading=true;
        this.vehicleService.getVehiclesList(personId).subscribe((res:any)=>{
          this.vehicleRes=res;
          //console.log(this.vehicleRes);
          this.isLoading=false;
          this.count=res.length;
          if(res.length==0){
            this.isEmpty=true;
          }
        })
    }

    getCarrierVehicle(personId){
      this.isLoading=true;
      this.vehicleEntryService.getCarrierVehiclesList(personId).subscribe((res:any)=>{
        this.vehicleRes=res;
        //console.log(this.vehicleRes);
        this.isLoading=false;
        this.count=res.length;
        if(res.length==0){
          this.isEmpty=true;
        }
      })
    }

    onReset = () => {
      this.selectedItems = [];
      this.regnumber = null;
      this.vehicleType = "";
      this.carriercode = "";
      this.permitType = "";
      this.utility.page = 1;
      this.vinnumber = "";
      this.carriername = "";
      this.message = 'Loading vehicles, please wait...';
      this.IsSearching = false;
      this.getVehicles(this.personsList[0].person_id);
    }

    onCarrierSearch=(page: number = 1, pageSize: number = 10) => {
      this.IsSearching = true;
      this.IsAdmin = false;
      this.utility.page = page;
      this.isLoading = true;
      this.vehicleRes = [];
      this.message = 'Searching your vehicles, please wait...';

      if(this.vehicleType ===""){
        this.vehicleType = null;
      }

      if(this.vinnumber === ""){
        this.vinnumber = null;
      }

      if(this.regnumber === ""){
        this.regnumber = null;
      }

      if(this.carriername === ""){
        this.carriername = null;
      }

      if(this.carriercode === ""){
        this.carriercode = null;
      }

      let object = {
        VehicleType:this.vehicleType,
        PermitType:this.permitType,
        VIN:this.vinnumber,
        Regnumber:this.regnumber,
        Carriername:this.carriername,
        CarrierId: this.carrierId,
        carriercode:this.carriercode,
        PageSize: pageSize,
        PageNumber:page,
        person_id: this.personsList[0].person_id
      }

      this.vehicleEntryService.searchExternalVehicle(object).subscribe((result:any) =>{

        if(result==null){

          this.vehicleRes = [];
          this.isLoading = false;
            return
        }
        this.vehicleRes=result.Items;
        //console.log(this.vehicleRes);
        this.isLoading=false;
        this.count=result.Count;
        if(result.length==0){
          this.isEmpty=true;
        }
      },error =>{
        this.isLoading = false;
      });
  }

  onChange = () => {
      this.onCarrierSearch(this.utility.page, this.pageSize);
  }

    onSearch=(page: number = 1, pageSize: number = 10) => {
      this.IsSearching = true;
      this.isLoading = true;
      this.message = 'Searching vehicles, please wait...';

      if(this.vehicleType ===""){
        this.vehicleType = null;
      }

      if(this.vinnumber === ""){
        this.vinnumber = null;
      }

      if(this.regnumber === ""){
        this.regnumber = null;
      }

      if(this.carriername === ""){
        this.carriername = null;
      }

      if(this.carriercode === ""){
        this.carriercode = null;
      }

      let object = {
        VehicleType:this.vehicleType,
        PermitType:this.permitType,
        VIN:this.vinnumber,
        Regnumber:this.regnumber,
        Carriername:this.carriername,
        carriercode:this.carriercode,
        PageSize: pageSize,
        PageNumber:page,
        person_id: this.getVehicles(this.personsList[0].person_id)
      }

      this.vehicleEntryService.searchExternalVehicle(object).subscribe((result:any) =>{
        if(result==null){
          //console.log("Search Result: "+ result);
          this.vehicleRes = [];
          this.isLoading = false;
            return;
        }

        this.vehicleRes=result.Items;
        //console.log(this.vehicleRes);
        this.isLoading=false;
        this.count=result.Count;
        this.utility.onSort(1);
        if(result.Items.length==0){
          this.isEmpty=true;
        }

    },error =>{
      this.isLoading = false;
    });

  }

  onNextOrPrevious(page: number = 1) {
    alert(page);
      this.onCarrierSearch(page, this.pageSize)
      this.currentPage = page;
      this.utility.page = page;
      return page;
  }

  loadAccounts(){
    this.isLoading=true;
    this.carrierService.listCarrierAccountsByUserId(this.user['ID']).subscribe((result:any) => {
      if(result.length>0){
        this.personsList=result;
        //console.log( this.personsList)
        this.getCarrierVehicle(result[0].person_id);
      }
    });
  }

  LeaseChange(){
    this.leased = this.myForm.value.is_leased;
    if(this.leased=='true'){
      this.myForm.get('vehicle_lessor').setValidators([Validators.required]);
      this.myForm.get('vehicle_lessee').setValidators([Validators.required]);
      this.myForm.get('date_lease_expiry').setValidators([Validators.required]);
    } else {
     this.myForm.get('vehicle_lessor').clearValidators();
     this.myForm.get('vehicle_lessee').clearValidators();
     this.myForm.get('date_lease_expiry').clearValidators();
    }
     this.myForm.get('vehicle_lessor').updateValueAndValidity();
     this.myForm.get('vehicle_lessee').updateValueAndValidity();
     this.myForm.get('date_lease_expiry').updateValueAndValidity();
   }

   numberOnly(event): boolean {
     const charCode = (event.which) ? event.which : event.keyCode;
     if (charCode > 31 && (charCode < 48 || charCode > 57)) {
       return false;
     }
     return true;
   }

   createForm(){
    this.isEditData = false;
    this.isViewData = false;
    this.isSouthAfrica = false;
    this.myForm = this.formBuilder.group({
      id:[-1,[]],
      permit_id:[],
      carrier_id:['', [Validators.required]],
      country_id: ['', [Validators.required]],
      registration_number: ['', [Validators.required]],
      registration_year: ['', [Validators.required]],
      vehicle_make_id: ['', []],
      vehicle_series: ['', []],
      vehicle_model: ['', [ ]],
      vehicle_colour: ['', []],
      vin: ['', [Validators.required,]],
      engine_number: ['', [Validators.required,]],
      gvn: ['', [Validators.required,]],
      seating_capacity: ['', []],
      date_license_expiry: ['', [Validators.required,]],
      start_date: ['', [Validators.required,]],
      vehicle_state: ['', []],
      roadworthy_status: ['', [Validators.required,]],
      vehicle_owner: ['', []],
      is_leased: [null, [Validators.required,]],
      vehicle_lessor: [''],
      vehicle_lessee: [''],
      date_lease_expiry: [''],
      vehicle_type_id: ['', [Validators.required]],
      api_date_updated: ['', []],
      eNatis_num:['',[]]
    });
    this.LeaseChange();    // hides the lease container
    this.found = false;    // hides the 'Retrieve from eNatis' button
    //this.disallowEdit = false; // allow fields to be edited
    this.myForm.controls.country_id.enable();
    this.myForm.controls.roadworthy_status.enable();
    this.myForm.controls.vehicle_type_id.enable();
    this.myForm.controls.is_leased.enable();
    this.myForm.controls.carrier_id.enable();
  }

  passForEdit(item){
    //console.log(item);
    this.isEditData = true;
    this.vehicleService.getVehicleBy(item.id).subscribe((x:any) =>{
      //console.log(x);
      this.leased = x.is_leased;
      if(item.country_id='undefined' && !item.country_id){
        item.country_id = x.country_id;
      }
      if(item.roadworthy_status ='undefined' && !item.roadworthy_status){
        item.roadworthy_status = x.roadworthy_status;
      }
      if(item.vehicle_type_id ='undefined' && !item.vehicle_type_id){
        item.vehicle_type_id = x.vehicle_type_id;
      }
      if(item.is_leased ='undefined' && !item.is_leased){
        item.is_leased = x.is_leased;
      }
      debugger;
      if(item.date_license_expiry == this.license_expiry_date_global){
        this.isEditData = false;
        return;
      }
      this.myForm.patchValue({
        id: item.id,
        date_license_expiry: item.date_license_expiry,
        gvn: item.gvn,
        registration_number:item.registration_number,
        registration_year:item.registration_year,
        seating_capacity:x.seating_capacity,
        start_date:item.start_date,
        vehicle_make_id:item.vehicle_make_id,
        vehicle_type_id: item.vehicle_type_id,
        vin: item.vin,
        permit_id:x.permit_id,
        country_id:x.country_id,
        vehicle_series: x.vehicle_series,
        vehicle_model: x.vehicle_model,
        vehicle_colour: x.vehicle_colour,
        engine_number: x.engine_number,
        vehicle_state:x.vehicle_state,
        roadworthy_status: x.roadworthy_status,
        vehicle_owner: x.vehicle_owner,
        is_leased:x.is_leased,
        vehicle_lessor: x.vehicle_lessor,
        vehicle_lessee: x.vehicle_lessee,
        date_lease_expiry:  this.datePipe.transform(x.date_lease_expiry,'dd/MM/yyyy'),
      });
    })
  }

  checkVin(value){
    if(value.length > 0){
      if (!this.myForm.value.country_id) {
        return this.toastr.warning("Please select the vehicle's Country-of-Registration before continuing.")
      }
      if(this.myForm.value['country_id']==113){
       // this.eNatisUpdate();
       this.found = true;  // displays the "Retrieve from eNatis" button
      }
    } else {
    // if (value.length === 0) {
      this.found = false;  // hides the "Retrieve from eNatis" button
    // }
    }
    if(value.length === 17 && this.myForm.value['country_id']==11 ){
      this.eNatisUpdate();
    }
   }

   eNatisUpdate(){
    this.eNatisCounter = this.eNatisCounter + 1;
    this.isVehicleLoading = true;
    // this.found = false;
    this.message = "Checking vehicle, please wait...";
    this.vehicleService.getVehicleValidatorByVin(this.myForm.value.vin).subscribe((data:any) => {
        if(data.Vin !== null){
          // if(this.myForm.value.registration_number.length > 0 && this.myForm.value.registration_number !== data.Registration_number){
          //   this.isVehicleLoading = false;
          //   return this.toastr.info('VIN and registration number do not match.');
          // }
          //console.log(data);
          this.eNatisResult=data;
          this.myForm.patchValue({
            country_id:113,
            vin:data.Vin,
            registration_number:data.Registration_number,
            vehicle_owner:data.Ownership,
            registration_year:this.datePipe.transform(data.Registration_year,'yyyy'),
            vehicle_colour: data.Vehicle_colour,
            vehicle_model: data.Vehicle_model,
            gvn:data.Gvm,
            engine_number:data.Engine_number,
            roadworthy_status:data.roadworthystatus,
            eNatis_num:data.enatis_num,
            date_license_expiry:this.datePipe.transform(data.Date_license_expiry,'dd/MM/yyyy'),
            seating_capacity:data.Seating_capacity
          });
          this.isVehicleLoading = false;
          this.isSouthAfrica = true;

          if (data.roadworthystatus === 'Not roadworthy') {
            return this.toastr.warning('Please note that according to eNatis this vehicle is not roadworthy and therefore will not be eligible for permit application.')
          } else {
            return this.toastr.success('Please enter Vehicle Type and Lease information.')
          }
        }

        if(data.NotFound === 'Not found'){
          // try 3 times to retrieve eNatis detail before displaying a failure message
          if(this.eNatisCounter <= 3){
            this.eNatisUpdate();
            return
          }
          // this.toastr.info('VIN and registration number do not match.');
          this.toastr.warning("Wasn't able to retrieve vehicle detail from eNatis - Please confirm VIN number is correct or try again later...");
          this.isVehicleLoading = false;
          if(this.isEditData == true){
            this.isSouthAfrica = true;
            //this.disallowEdit = true;
          }
          return
        } else {
          this.eNatisCounter = 0;
        }

        if(data.NetworkError === 'Network error'){
          this.toastr.error('The eNatis system is offline at the moment - Please try again later.')
          this.isVehicleLoading = false;
          this.isSouthAfrica = false;
          //this.disallowEdit = false;
          return
        }
      })
  }

  getCarrierVehicleEntry(id){
    this.vehicleEntryCarierService.getVehicleEntryCarrier(id).subscribe((x:any)=>{
      //console.log(x)
      this.leased = x.vehicle_entry.is_leased;
      // this.isEditData=true;

      // if South African registered vehicle, do not allow changes to eNatis fields
      // but allow for updates from eNatis
      if(x.vehicle_entry.country_id === 113){
        this.isSouthAfrica = true;
        //this.disallowEdit = true;
        this.found = true;
      } else {
        this.isSouthAfrica = false;
        //this.disallowEdit = false;
        this.found = false;
      }

      this.myForm.patchValue({
        carrier_id:x.carrier_id,
        id: x.vehicle_entry.id,
        date_license_expiry: this.datePipe.transform(x.vehicle_entry.date_license_expiry,'dd/MM/yyyy'),
        gvn: x.vehicle_entry.gvn,
        registration_number:x.vehicle_entry.registration_number,
        registration_year:x.vehicle_entry.registration_year,
        seating_capacity:x.vehicle_entry.seating_capacity,
        vehicle_make_id:x.vehicle_entry.vehicle_make_id,
        vehicle_type_id: x.vehicle_entry.vehicle_type_id,
        vin: x.vehicle_entry.vin,
        country_id:x.vehicle_entry.country_id,
        vehicle_series: x.vehicle_entry.vehicle_series,
        vehicle_model: x.vehicle_entry.vehicle_model,
        vehicle_colour: x.vehicle_entry.vehicle_colour,
        engine_number: x.vehicle_entry.engine_number,
        vehicle_state:x.vehicle_entry.vehicle_state,
        roadworthy_status: x.vehicle_entry.roadworthy_status,
        vehicle_owner: x.vehicle_entry.vehicle_owner,
        is_leased:x.vehicle_entry.is_leased,
        vehicle_lessor: x.vehicle_entry.vehicle_lessor,
        vehicle_lessee: x.vehicle_entry.vehicle_lessee,
        date_lease_expiry:  this.datePipe.transform(x.vehicle_entry.date_lease_expiry,'dd/MM/yyyy'),
            })
      $("#addEdit").modal('show');
      this.isLoading=false;

    },error =>{
      //console.log(error)
    })
  }

  editVehicle(item){
    this.isLoading=true;
    // this.getCarrierVehicleEntry(item.id);
    $(".action").val('null');
    this.vehicleEntryService.getVehicleEntryById(item.id).subscribe((x:any)=>{

      //console.log(x);

      if(x!=null){

        this.leased = x.is_leased;
        this.license_expiry_date_global = this.datePipe.transform(x.date_license_expiry, 'dd/MM/yyyy');
        
        if(x.country_id==113){
          this.isSouthAfrica = true;
        } else {
          this.isSouthAfrica = false;
        }
        
        // this.isEditData=true;
        this.myForm.patchValue({
          id: x.id,
          date_license_expiry: this.datePipe.transform(x.date_license_expiry,'dd/MM/yyyy'),
          gvn: x.gvn,
          registration_number:x.registration_number,
          registration_year:x.registration_year,
          seating_capacity:x.seating_capacity,
          vehicle_make_id:x.vehicle_make_id,
          vehicle_type_id: x.vehicle_type_id,
          vin: x.vin,
          country_id:x.country_id,
          vehicle_series: x.vehicle_series,
          vehicle_model: x.vehicle_model,
          vehicle_colour: x.vehicle_colour,
          engine_number: x.engine_number,
          vehicle_state:x.vehicle_state,
          roadworthy_status: x.roadworthy_status,
          vehicle_owner: x.vehicle_owner,
          eNatis_num:x.vehicle_register_num,
          is_leased:x.is_leased,
          vehicle_lessor: x.vehicle_lessor,
          vehicle_lessee: x.vehicle_lessee,
          date_lease_expiry:  this.datePipe.transform(x.date_lease_expiry,'dd/MM/yyyy'),
        });

        $("#addEdit").modal('show');

      }
      this.isLoading=false;
    });

  }

  changeCountry(countryId) {
    //console.log(this.myForm.value.country_id);
    this.found = false;  // hides the 'Retrieve from eNatis' button

    if (countryId.value != 113) {
      this.resetForm();
    }

    if (this.myForm.value.country_id === 113) {
      this.isSouthAfrica = true;

      // this.myForm.controls.registration_number.disable();
      // this.myForm.controls.vehicle_owner.disable();
      // this.myForm.controls.registration_year.disable();
      // this.myForm.controls.vehicle_colour.disable();
      // this.myForm.controls.vehicle_model.disable();
      // this.myForm.controls.gvn.disable();
      // this.myForm.controls.engine_number.disable();
      // this.myForm.controls.roadworthy_status.disable();
      // this.myForm.controls.eNatis_num.disable();
      // this.myForm.controls.date_license_expiry.disable();
      // this.myForm.controls.seating_capacity.disable();
      // this.myForm.controls.vehicle_make_id.disable();
      // this.myForm.controls.vehicle_type_id.disable();
      // this.myForm.controls.is_leased.disable();
      // this.myForm.controls.vehicle_lessor.disable();
      // this.myForm.controls.vehicle_lessee.disable();
      // this.myForm.controls.date_lease_expiry.disable();

    } else {
      this.isSouthAfrica = false;

      // this.myForm.controls.registration_number.enable();
      // this.myForm.controls.vehicle_owner.enable();
      // this.myForm.controls.registration_year.enable();
      // this.myForm.controls.vehicle_colour.enable();
      // this.myForm.controls.vehicle_model.enable();
      // this.myForm.controls.gvn.enable();
      // this.myForm.controls.engine_number.enable();
      // this.myForm.controls.roadworthy_status.enable();
      // this.myForm.controls.eNatis_num.enable();
      // this.myForm.controls.date_license_expiry.enable();
      // this.myForm.controls.seating_capacity.enable();
      // this.myForm.controls.vehicle_make_id.enable();
      // this.myForm.controls.vehicle_type_id.enable();
      // this.myForm.controls.is_leased.enable();
      // this.myForm.controls.vehicle_lessor.enable();
      // this.myForm.controls.vehicle_lessee.enable();
      // this.myForm.controls.date_lease_expiry.enable();
    }
  }

  checkRoadworthy (event: any) {
    if(event.target.value === 'Unroadworthy'){
     if (this.myForm.value.country_id === 113) {
         this.toastr.warning('Please note that according to eNatis this vehicle is not roadworthy and therefore will not be eligible for permit application.')
       } else {
         this.toastr.warning('Please note that according to your selection this vehicle is not roadworthy and therefore will not be eligible for permit application.')
       }
     return
    }
  }

/*   checkCountrySelection (event: any) {
    if (this.isVehicleLoading = true){
    } else {
      if (!this.myForm.value.country_id) {
        this.toastr.info("Please select the vehicle's Country-of-Registration before continuing.")
       }
    }
    return
  } */

resetForm(){
  this.eNatisResult=null;
  this.myForm.patchValue({
    vin:'',
    registration_number:'',
    engine_number:'',
    gvn:'',
    seating_capacity: '',
    registration_year:'',
    date_license_expiry:null,
    roadworthy_status:'',
    eNatis_num:'',
    vehicle_type_id:'',
    carrier_id:'',
    is_leased:'',
    vehicle_lessor:'',
    vehicle_lessee:'',
    date_lease_expiry:null,
    vehicle_owner:'',
    vehicle_colour: '',
    vehicle_model: '',
  });
  this.LeaseChange();  // hides the lease container
  this.found = false;  // hides the 'Retrieve from eNatis' button
  //this.disallowEdit = false;
  this.myForm.controls.country_id.enable();
  this.myForm.controls.roadworthy_status.enable();
  this.myForm.controls.vehicle_type_id.enable();
  this.myForm.controls.is_leased.enable();
  this.myForm.controls.carrier_id.enable();
}

  SaveModal(){
    //console.log(this.myForm.value);

    this.myForm.value.vehicle_make_id=this.selectedVMake.id ;

    if(!this.myForm.value.country_id){
      return this.toastr.warning('Country of vehicle registration is required!','Country Of Vehicle Registration');
    }
    if(!this.myForm.value.registration_number){
      return this.toastr.warning('Vehicle registration number is required!','Vehicle Registration Number');
    }
    // if(!this.myForm.value.vehicle_make_id){
    //   return this.toastr.warning('Vehicle make is required!','Vehicle Make');
    // }
    if(!this.myForm.value.vin){
      return this.toastr.warning('VIN or Chassis number is required!','VIN or Chassis Number');
    }
    // if(this.myForm.value.vin.length !== 17){
    //   return this.toastr.warning('VIN should be 17 alphanumeric characters.','VIN or Chassis Number')
    // }
    if(!this.myForm.value.engine_number){
      return this.toastr.warning('Engine number is required!','Engine Number');
    }
    if(!this.myForm.value.gvn){
      return this.toastr.warning('Gross Vehicle(GVM) is required!','Gross Vehicle(GVM)');
    }
    if(!this.myForm.value.date_license_expiry){
      return this.toastr.warning('License expiry date is required!','License Expiry Date');
    }
    // if(!this.myForm.value.start_date){
    //   return this.toastr.warning('Start Date is required!','Permit Start Date');
    // }
    if(!this.myForm.value.roadworthy_status){
      return this.toastr.warning('Roadworthy status is required!','Roadworthy Status');
    }
    if(!this.myForm.value.vehicle_type_id){
      return this.toastr.warning('Vehicle type is required!','Vehicle Type');
    }

    if(this.myForm.value.is_leased == null){
      return this.toastr.warning('Is the vehicle leased?','Vehicle');
    }
    if(!this.myForm.value.carrier_id){
      return this.toastr.warning('Carrier Account is required','Carrier Account');
    }
    if(this.leased === true || this.leased === 'true'){
      //console.log('inside')
      if(!this.myForm.value.vehicle_lessor){
        return this.toastr.warning('Lessor name is required!','Lessor Name');
      }
      if(!this.myForm.value.vehicle_lessee){
        return this.toastr.warning('Lessee name is required!','Lessee Name');
      }
      if(!this.myForm.value.date_lease_expiry){
        return this.toastr.warning('Expiry date of lease is required!','Expiry Date Of Lease');
      }
    }
      if(!(parseInt(this.myForm.value.registration_year) >= 1950 && parseInt(this.myForm.value.registration_year) <=2100)){
        this.toastr.warning("Invalid Registration Year");
        return false;
      }
    if(this.leased === false || this.leased === 'false'){
      this.myForm.value.vehicle_lessor = '';
      this.myForm.value.vehicle_lessee = '';
      this.myForm.value.date_lease_expiry = '';
    }

    if(this.myForm.value.date_license_expiry){
      let date_license_expiry = this.myForm.value.date_license_expiry
      let date = date_license_expiry.split('/');
      let  day = parseInt(date[0], 10);
      let  month = parseInt(date[1], 10);
      let  year = parseInt(date[2], 10);
      let newDate = year + '/'+ month + '/' + day;
      let newDate1 = new  Date (newDate);
      newDate1.setDate(newDate1.getDate() + 1);
      this.myForm.value.date_license_expiry = newDate1;
    }

    if(this.myForm.value.date_lease_expiry){
      let  date_lease_expiry = this.myForm.value.date_lease_expiry;
      let date1 = date_lease_expiry.split('/');
      let  day1 = parseInt(date1[0], 10);
      let  month1 = parseInt(date1[1], 10);
      let  year1 = parseInt(date1[2], 10);
      let newDate2 = year1 + '/'+ month1 + '/' + day1;
      let newDate11 = new  Date (newDate2);
      newDate11.setDate(newDate11.getDate() + 1);
      this.myForm.value.date_lease_expiry = newDate11;
    }

      this.myForm.value.user_modified = this.myForm.value.user_created = environment.authWebApi.userData.User.FirstName,
      this.myForm.value.vehicle_register_num=this.myForm.value.eNatis_num;
      // if(this.myForm.value.registration_year.includes('-')){
      //   let date = this.myForm.value.registration_year.split('-');
      //   let  year = parseInt(date[2], 10);
      //   this.myForm.value.registration_year = year

      // }
    //console.log(this.myForm.value);
    this.isVehicleLoading = true;

              if(this.myForm.value.id==-1){
              // new entry - insert only for account if not already exists - do not update by creating a "new" vehicle
              this.vehicleEntryService.postCarrierVehicleEntry(this.myForm.value,this.myForm.value.carrier_id).subscribe(itemRes=>{
                //console.log(itemRes)
                if (itemRes == 'Updated') {
                  this.toastr.info('Vehicle details already exists for this carrier. Updated details successfully.', 'Vehicle already in register');
                } 
                else if(itemRes == 'AlreadyInPermit')
                {
                  this.toastr.info('Vehicle details already exists in active Permit.', 'Vehicle already in active Permit');
                }
                else {
                  this.toastr.success('Saved Vehicle Details');

                }
                    this.isVehicleLoading = true;
                    $("#addEdit").modal('hide');
                   // this.getApp(this.appid);
                   this.loadAccounts();
                  this.isVehicleLoading=false;
              },(err)=>{
                this.isVehicleLoading=false;
                this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Save Application')
              });
            }else{
              // vehicle exists - update
              this.isVehicleLoading=true;
              this.vehicleEntryService.postCarrierVehicleEntry(this.myForm.value,this.myForm.value.carrier_id).subscribe(itemRes=>{
                  this.toastr.success('Updated Vehicle Details');
                  this.isVehicleLoading = false;
                  $("#addEdit").modal('hide');
                 // this.getApp(this.appid);
                 this.loadAccounts();
                },(err)=>{
                  this.isVehicleLoading = false;
                  this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Save Application')
                });
            }
  }

  CloseModal(){
    $("#addEdit").modal('hide');
    this.isEditData=false;
    this.passForEdit(this.myForm.value);
    //this.disallowEdit=false;
    this.isViewData=false;
    this.isSouthAfrica=false;
    this.isVehicleLoading = false;
    this.myForm.controls.country_id.enable();
    this.myForm.controls.roadworthy_status.enable();
    this.myForm.controls.vehicle_type_id.enable();
    this.myForm.controls.is_leased.enable();
    this.myForm.controls.carrier_id.enable();
    if(this.isEditData){
      this.isVehicleLoading = true;
      if (this.myForm.value.date_license_expiry) {
        let date_license_expiry = this.myForm.value.date_license_expiry
        let date = date_license_expiry.split('/');
        let day = parseInt(date[0], 10);
        let month = parseInt(date[1], 10);
        let year = parseInt(date[2], 10);
        let newDate = year + '/' + month + '/' + day;
        let newDate1 = new Date(newDate);
        newDate1.setDate(newDate1.getDate() + 1);
        this.myForm.value.date_license_expiry = newDate1;     
      }

      this.vehicleEntryService.postCarrierVehicleEntry(this.myForm.value,this.myForm.value.carrier_id).subscribe(itemRes=>{
        this.loadAccounts();
        this.isVehicleLoading = false;
      }, (err) => {
        this.isVehicleLoading = false;
        console.log(`failed, ${err}`);
      }); 
    }
  }

  selectAction(actionType,res){
    if(actionType.value=='view'){
      this.isViewData=true;
      this.isEditData=false;
      this.editVehicle(res);
      this.myForm.controls.country_id.disable();
      this.myForm.controls.roadworthy_status.disable();
      this.myForm.controls.vehicle_type_id.disable();
      this.myForm.controls.is_leased.disable();
      this.myForm.controls.carrier_id.disable();
    }
    else if(actionType.value=='edit'){
      this.isEditData=true;
      this.isViewData=false;   
      this.editVehicle(res);  
      this.myForm.controls.country_id.enable();
      this.myForm.controls.roadworthy_status.enable();
      this.myForm.controls.vehicle_type_id.enable();
      this.myForm.controls.is_leased.enable();
      this.myForm.controls.carrier_id.enable();
    }
    // if(actionType.value =='delete')
    // {
    //   this.OndeleteVehicle(res)
    // }
    // if(actionType.value=='upload'){
    //   this.selectItem=res;
    //   this.uploadDocs(res);
    // }
    return
  }

  OndeleteVehicle(vehicle){

    this.getCarrierVehicleEntry(vehicle.id);
    if(vehicle.Permit.is_valid)
    {
      this.toastr.warning('Cannot delete a valid permit');
      return;
    }

    // this.msgService.showYesNo('Delete Vehicle', `Are you sure you want to delete this vehicle`, '').subscribe(isConfirmed => {

    //   if (isConfirmed) {

    //     let object = {
    //       vehicle_entry:vehicle.id,
    //       carrier_id:this.myForm.value.carrier_id,
    //       permit_id:vehicle.permit_id
    //     }

    //     if(this.carrierId =="")
    //     {
    //       this.toastr.success("Please filter by one carrier",'Vehicle');
    //       return;
    //     }

    //     //console.log("vehicle object: " + JSON.stringify(vehicle));
    //     this.vehicleEntryService.deletevehicle(object).subscribe((result:any) =>{
    //       this.isLoading = true;
    //       if(result!=null){
    //         //console.log("Delete object: " +JSON.stringify(result));
    //         this.toastr.success( JSON.stringify(result.Value),'Vehicle');

    //         this.isLoading = false;
    //         return;

    //       } else{
    //                this.toastr.warning('No vehicle entry record found','Vehicle');
    //                this.isLoading = false;
    //       }
    //   },error =>{
    //     this.isLoading = false;
    // });

    //     }

    //   });
      this.confirmDialogService.confirmThis("Are you sure you want to delete this vehicle?", () => {  
          

          let object = {
            vehicle_entry:vehicle.id,
            carrier_id:this.myForm.value.carrier_id,
            permit_id:vehicle.permit_id
          }
  
          if(this.carrierId =="")
          {
            this.toastr.success("Please filter by one carrier",'Vehicle');
            return;
          }
  
          //console.log("vehicle object: " + JSON.stringify(vehicle));
          this.vehicleEntryService.deletevehicle(object).subscribe((result:any) =>{
            this.isLoading = true;
            if(result!=null){
              //console.log("Delete object: " +JSON.stringify(result));
              this.toastr.success( JSON.stringify(result.Value),'Vehicle');
  
              this.isLoading = false;
              return;
  
            } else{
                     this.toastr.warning('No vehicle entry record found','Vehicle');
                     this.isLoading = false;
            }
        },error =>{
          this.isLoading = false;
      });
  
      
      }, () =>  {  
        //No here
      })
  }

  close() {
    this.isSouthAfrica = false;
    //this.disallowEdit = false;
  }
}
